import { User } from "../Models/User";
import { Contrat } from "../Models/Contrat";
import { Notyf } from "notyf";

export async function getAuthenticatedUser() {
    const user = await $.getJSON("/users/me.json");
    return user as User;
}
/**
 * Déclaré dans le layout/default.php
 */
declare const csrfToken: string;

export function getCsrfToken() {
    return csrfToken;
}

/**
 * Cache des autorisations, par couple `module/action`.
 *
 * Une meme autorisation est demandee par plusieurs controleurs au chargement
 * d'une page (SHOW_DRIVE_START_END l'etait 4 fois sur /Vehicules/index). On
 * memoise la *promesse* et non le resultat : des appels concurrents emis
 * avant l'arrivee de la reponse partagent alors le meme aller-retour reseau,
 * au lieu d'en declencher un chacun.
 *
 * Les droits ne changent pas pendant la vie de la page : pas d'invalidation.
 */
const allowedCache = new Map<string, Promise<boolean>>();

export async function userIsAllowedTo(
    codeAction: string,
    module: string,
    notifyNotAllowedTo: boolean = false,
): Promise<boolean> {
    const key = `${module}/${codeAction}`;
    let pending = allowedCache.get(key);

    if (pending === undefined) {
        pending = (async () => Boolean(await $.getJSON(`/users/isAllowed/${key}.json`)))();
        // Une erreur reseau ne doit pas empoisonner le cache pour toute la
        // duree de la page : on retire l'entree pour permettre un reessai.
        pending.catch(() => allowedCache.delete(key));
        allowedCache.set(key, pending);
    }

    const allowed = await pending;

    if (notifyNotAllowedTo && !allowed) {
        notifyPreferenceNotAllowed();
    }

    return allowed;
}

export function notifyPreferenceNotAllowed(message: string = "Vous n'êtes pas autorisé(e) à effectuer cette action.") {
    const notyf = new Notyf({
        duration: 5000,
        dismissible: true,
        position: {
            x: "center",
            y: "top",
        },
    });

    notyf.error(message);
}

let currentContrat: Contrat | null = null;

export async function getCurrentContrat() {
    if (currentContrat == null) {
        currentContrat = (await $.getJSON("/contrats/current.json")) as Contrat | null;
    }
    return currentContrat;
}
